import { ChevronLeft, ChevronRight } from 'lucide-react'
import SurahCard, { type Surah } from './SurahCard'

interface ContinueReadingSectionProps {
  currentSurah: Surah | null
  previousSurah?: Surah | null
  nextSurah?: Surah | null
  selectedReciterId?: string | null
  onListen?: (surahNumber: number) => void
}

export default function ContinueReadingSection({
  currentSurah,
  previousSurah,
  nextSurah,
  selectedReciterId = null,
  onListen,
}: ContinueReadingSectionProps) {
  if (!currentSurah && !previousSurah && !nextSurah) {
    return null
  }

  return (
    <div className="bg-primary-50 rounded-lg p-6 mb-8">
      <h3 className="text-xl font-bold text-gray-900 mb-6">متابعة القراءة</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {previousSurah && (
          <div className="relative">
            <div className="absolute top-2 right-2 text-xs text-gray-500 flex items-center gap-1">
              <ChevronRight className="w-4 h-4" />
              السابق
            </div>
            <SurahCard 
              surah={previousSurah} 
              selectedReciterId={selectedReciterId}
              onListen={onListen ? () => onListen(previousSurah.number) : undefined}
            />
          </div>
        )}

        {currentSurah && (
          <div>
            <SurahCard 
              surah={currentSurah} 
              isContinueReading={true} 
              selectedReciterId={selectedReciterId}
              onListen={onListen ? () => onListen(currentSurah.number) : undefined}
            />
          </div>
        )}

        {nextSurah && (
          <div className="relative">
            <div className="absolute top-2 left-2 text-xs text-gray-500 flex items-center gap-1">
              التالي
              <ChevronLeft className="w-4 h-4" />
            </div>
            <SurahCard 
              surah={nextSurah} 
              selectedReciterId={selectedReciterId}
              onListen={onListen ? () => onListen(nextSurah.number) : undefined}
            />
          </div>
        )}
      </div>
    </div>
  )
}

